"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkServiceConflictCardCms = void 0;
var dslservice_cms_1 = require("./dslservice.cms");
var internetservice_cms_1 = require("./internetservice.cms");
var existingservice_cms_1 = require("./existingservice.cms");
var hardstopcto_cms_1 = require("./hardstopcto.cms");
var WorkServiceConflictCardCms = /** @class */ (function () {
    function WorkServiceConflictCardCms() {
        this.dslService = new dslservice_cms_1.DslServiceCms();
        this.internetService = new internetservice_cms_1.InternetServiceCms();
        this.existingService = new existingservice_cms_1.ExistingServiceCms();
        this.hardStopCTO = new hardstopcto_cms_1.HardStopCTOCms();
    }
    return WorkServiceConflictCardCms;
}());
exports.WorkServiceConflictCardCms = WorkServiceConflictCardCms;
//# sourceMappingURL=workserviceconflictcard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/workserviceconflictcard.cms.js
// module id = 1980
// module chunks = 8